import { Box } from '@material-ui/core';
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import OpsCreateNodeTool from './OpsCreateNodeTool';
import OpsMiscTools from './OpsMiscTools';
import OpsUpdateNodeTool from './OpsUpdateNodeTool';

const OpsPageContent : React.FC = () => {
    return (
        <Box mt={2}>
            <Switch>
                <Route path='/ops/create-node'><OpsCreateNodeTool /></Route>
                <Route path='/ops/update-node'><OpsUpdateNodeTool /></Route>
                <Route path='/ops/other'><OpsMiscTools /></Route>
            </Switch>
        </Box>
    )
}

export default OpsPageContent;